// -----------------------------------------------------------------------------
// Feedback tattile opzionale (Fase 6) — navigator.vibrate, molto breve.
// Fallback silenzioso dove non disponibile (tipico su Safari iOS).
// Nessuna libreria esterna. La sua assenza non blocca mai il gameplay.
// -----------------------------------------------------------------------------
export function vibrateTap() {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(10); // impulso breve e non invasivo
    }
  } catch {
    // no-op
  }
}
